function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.3
}, React.createElement("path", {
  d: "M28.4082 1.05524C26.8732 0.382617 25.1269 0.382617 23.5919 1.05524L2.60674 10.2509C1.15194 10.8884 0.212158 12.3262 0.212158 13.9146V33.1507C0.212158 34.0409 0.93376 34.7625 1.8239 34.7625C2.71404 34.7625 3.43564 34.0409 3.43564 33.1507V16.2888L9.88261 18.7693V32.8227C9.88261 33.4102 10.1754 33.9591 10.6633 34.2864C10.6633 34.2864 17.6517 38.9443 26 38.9443C34.3484 38.9443 41.3368 34.2864 41.3368 34.2864C41.8247 33.9591 42.1175 33.4102 42.1175 32.8227V18.7693L49.9869 15.7527C51.0717 15.3369 51.7879 14.2953 51.7879 13.1335C51.7879 12.0197 51.1289 11.0114 50.1087 10.5644L28.4082 1.05524ZM24.7979 4.32929C25.5643 3.99408 26.4358 3.99408 27.2022 4.32928L47.2045 13.0779L27.0725 20.7842C26.382 21.0485 25.6181 21.0485 24.9276 20.7842L4.79555 13.0779L24.7979 4.32929ZM13.1061 19.9958L23.8537 24.1195C25.2356 24.6498 26.7647 24.6505 28.1472 24.1215L38.894 20.0096V31.6405C37.8363 32.2882 32.5477 35.4164 26 35.4164C19.4523 35.4164 14.1638 32.2882 13.1061 31.6405V19.9958ZM1.8239 38.2903C0.929887 38.2903 0.212158 39.0758 0.212158 40.0543C0.212158 41.0327 0.929887 41.8182 1.8239 41.8182C2.71791 41.8182 3.43564 41.0327 3.43564 40.0543C3.43564 39.0758 2.71791 38.2903 1.8239 38.2903Z",
  fill: "#767B87"
}));

const SvgNoTrainingIcon = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 52,
    height: 46,
    viewBox: "0 0 52 46",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgNoTrainingIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/no_training_icon.3e6600f3.svg";
export { ForwardRef as ReactComponent };